export const arrowDownSVG = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_31795_335642)">
<rect width="24" height="24" transform="matrix(0 -1 1 0 0 24)" fill="white" fill-opacity="0.01"/>
<path d="M6.71047 9.28953C6.32047 9.67953 6.32047 10.3095 6.71047 10.6995L11.3005 15.2895C11.6905 15.6795 12.3205 15.6795 12.7105 15.2895L17.3005 10.6995C17.6905 10.3095 17.6905 9.67953 17.3005 9.28953C16.9105 8.89953 16.2805 8.89953 15.8905 9.28953L12.0005 13.1695L8.12047 9.28953C7.73047 8.89953 7.09047 8.90953 6.71047 9.28953V9.28953Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_31795_335642">
<rect width="24" height="24" fill="white" transform="matrix(0 -1 1 0 0 24)"/>
</clipPath>
</defs>
</svg>
`;
